import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

const articleCategories = ['全部', '营养知识', '优惠活动', '品牌新闻'];

export default function Articles() {
  const [activeCat, setActiveCat] = useState('全部');

  const filtered = useMemo(() => {
    if (activeCat === '全部') return articles;
    return articles.filter((a) => a.category === activeCat);
  }, [activeCat]);

  return (
    <>
      <PageMeta
        title="文章资讯 - 爱威奶在线 | 牛奶营养知识与品牌动态"
        description="爱威奶在线文章资讯，涵盖牛奶营养知识、产品优惠活动、品牌最新动态，帮助您了解更多关于牛奶的科普知识与选购技巧。"
        keywords="牛奶营养知识,牛奶优惠活动,爱威奶品牌新闻,牛奶选购指南,牛奶科普"
        canonicalUrl="https://www.aiweinai.com/articles"
      />

      <Navbar />

      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: '文章资讯' },
          ]} />

          <div className="mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              文章资讯
            </h1>
            <p className="text-sm text-foreground-500">
              了解牛奶营养知识、优惠活动和品牌最新动态
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex items-center gap-2 flex-wrap mb-10">
            {articleCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCat(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCat === cat
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {filtered.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filtered.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-article-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无相关文章</p>
            </div>
          )}
        </div>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "文章资讯 - 爱威奶在线",
          "description": "爱威奶在线文章资讯，涵盖牛奶营养知识、产品优惠活动、品牌最新动态。",
          "url": "https://www.aiweinai.com/articles",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.aiweinai.com" },
              { "@type": "ListItem", "position": 2, "name": "文章资讯", "item": "https://www.aiweinai.com/articles" },
            ],
          },
        }),
      }} />
    </>
  );
}